import { render, staticRenderFns } from "./OFormPhotoComp.vue?vue&type=template&id=342c816d&"
import script from "./OFormPhotoComp.vue?vue&type=script&lang=js&"
export * from "./OFormPhotoComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports